export default __webpack_public_path__ + "static/media/avatar-3.605f4f9b.svg";